import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';

export const authGuard: CanActivateFn = async () => {
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  try {
    const session = await supabaseService.getSession();

    if (session) {
      return true;
    }
  } catch {
    // Falha ao verificar sessão: redireciona para login
  }

  return router.createUrlTree(['/auth/login']);
};
